import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'Hakkımızda | İzmir Vize Danışmanlığı - 12 Yıllık Deneyim';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Karşıyaka Visa Consulting olarak 12 yıllık deneyimimiz ile İzmir vize danışmanlığı alanında profesyonel hizmet sunuyoruz. Güvenilir, hızlı ve başarılı vize süreçleri.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-8 md:py-16 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }}></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-3 md:mb-4">
              Hakkımızda
            </span>
            <h1 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-cream-100 mb-3 md:mb-4">
              12 Yıllık Deneyim ile<br />İzmir Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-sm md:text-lg max-w-3xl mx-auto leading-relaxed">
              Karşıyaka Visa Consulting olarak, vize süreçlerinde güvenilir ve profesyonel çözüm ortağınızız
            </p>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-8 md:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
              <div>
                <img
                  src="https://public.readdy.ai/ai/img_res/f012e5054c1e78aee30d930e7088377c.jpg"
                  alt="Karşıyaka Visa Consulting Ofis"
                  className="w-full h-full object-cover object-top rounded-xl md:rounded-2xl shadow-2xl"
                />
              </div>
              
              <div className="space-y-3 md:space-y-4">
                <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-navy-900 mb-3 md:mb-4">
                  Hikayemiz
                </h2>
                
                <p className="text-navy-700 text-sm md:text-base leading-relaxed">
                  <strong>Karşıyaka Visa Consulting</strong>, 2013 yılında İzmir'in kalbi Karşıyaka'da kurulmuştur. 
                  12 yıllık deneyimimiz boyunca, binlerce kişinin hayallerini gerçekleştirmesine yardımcı olduk. 
                  İzmir vize danışmanlığı alanında öncü konumumuz, müşterilerimize sunduğumuz kaliteli hizmet ve 
                  yüksek başarı oranımızla sektörde fark yarattık.
                </p>
                
                <p className="text-navy-700 text-sm md:text-base leading-relaxed">
                  Vize süreçlerinin karmaşık ve stresli olabileceğinin farkındayız. Bu nedenle, her müşterimize 
                  özel ilgi göstererek, başvuru sürecinin her aşamasında yanlarında oluyoruz. İzmir vize danışmanlığı 
                  hizmetlerimiz, Schengen ülkeleri, Amerika, İngiltere ve daha birçok destinasyonu kapsamaktadır.
                </p>
                
                <p className="text-navy-700 text-sm md:text-base leading-relaxed">
                  Profesyonel ekibimiz, sürekli güncellenen vize mevzuatlarını yakından takip ederek, 
                  müşterilerimize en güncel ve doğru bilgileri sunmaktadır. İzmir vize danışmanlığı alanındaki 
                  uzmanlığımız, yıllar içinde kazandığımız tecrübe ve başarılı başvurularımızla kanıtlanmıştır.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-8 md:py-16 bg-cream-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-6 md:mb-10">
              <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-navy-900 mb-2 md:mb-3">
                Değerlerimiz
              </h2>
              <p className="text-navy-600 text-sm md:text-base">
                İzmir vize danışmanlığı hizmetlerimizde bizi öne çıkaran değerler
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: 'Güvenilirlik',
                  desc: '12 yıllık deneyimimiz ve binlerce başarılı başvuru ile güvenilir hizmet sunuyoruz.',
                },
                {
                  icon: 'ri-speed-line',
                  title: 'Hız',
                  desc: 'Vize süreçlerinizi en kısa sürede tamamlayarak zamanınızı değerli kılıyoruz.',
                },
                {
                  icon: 'ri-user-heart-line',
                  title: 'Müşteri Odaklılık',
                  desc: 'Her müşterimize özel ilgi göstererek, ihtiyaçlarına özel çözümler üretiyoruz.',
                },
                {
                  icon: 'ri-award-line',
                  title: 'Profesyonellik',
                  desc: 'Uzman kadromuz ve güncel bilgilerimizle profesyonel destek sağlıyoruz.',
                },
              ].map((value, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center"
                >
                  <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center bg-navy-900 rounded-lg md:rounded-xl mx-auto mb-2 md:mb-4">
                    <i className={`${value.icon} text-lg md:text-2xl text-cream-400`}></i>
                  </div>
                  <h3 className="font-display text-sm md:text-lg font-bold text-navy-900 mb-1 md:mb-2">
                    {value.title}
                  </h3>
                  <p className="text-navy-600 text-xs md:text-sm leading-relaxed">
                    {value.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section className="py-8 md:py-16 bg-navy-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center">
              <div className="space-y-3 md:space-y-5">
                <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-cream-100">
                  12 Yıllık Deneyimimiz
                </h2>
                
                <p className="text-cream-200 text-sm md:text-base leading-relaxed">
                  2013 yılından bu yana İzmir vize danışmanlığı alanında faaliyet gösteriyoruz. 
                  Bu süre zarfında, vize mevzuatlarındaki tüm değişiklikleri yakından takip ederek, 
                  müşterilerimize en güncel ve doğru bilgileri sunmayı başardık.
                </p>
                
                <p className="text-cream-200 text-sm md:text-base leading-relaxed">
                  Schengen ülkeleri, Amerika Birleşik Devletleri, İngiltere ve daha birçok destinasyon 
                  için binlerce başarılı vize başvurusu gerçekleştirdik. Her geçen yıl artan müşteri 
                  memnuniyeti ve başarı oranımız, İzmir vize danışmanlığı alanındaki lider konumumuzu 
                  pekiştirmektedir.
                </p>
                
                <p className="text-cream-200 text-sm md:text-base leading-relaxed">
                  Ekibimiz, vize süreçlerinin her aşamasında müşterilerimize rehberlik etmekte, 
                  evrak hazırlığından randevu alımına, başvuru takibinden sonuç bildirimine kadar 
                  tüm süreçleri titizlikle yönetmektedir. İzmir vize danışmanlığı hizmetlerimizde 
                  kalite ve güvenilirlik her zaman önceliğimizdir.
                </p>

                <div className="grid grid-cols-3 gap-2 md:gap-4 pt-3 md:pt-5">
                  <div className="text-center">
                    <div className="font-display text-2xl md:text-4xl font-bold text-cream-400 mb-1">5000+</div>
                    <div className="text-cream-300 text-xs md:text-sm">Başarılı Başvuru</div>
                  </div>
                  <div className="text-center">
                    <div className="font-display text-2xl md:text-4xl font-bold text-cream-400 mb-1">4500+</div>
                    <div className="text-cream-300 text-xs md:text-sm">Mutlu Müşteri</div>
                  </div>
                  <div className="text-center">
                    <div className="font-display text-2xl md:text-4xl font-bold text-cream-400 mb-1">25+</div>
                    <div className="text-cream-300 text-xs md:text-sm">Ülke</div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="bg-cream-400 rounded-xl md:rounded-2xl p-5 md:p-10 shadow-2xl">
                  <div className="text-center mb-4 md:mb-6">
                    <div className="font-display text-5xl md:text-7xl font-bold text-navy-900 leading-none mb-2 md:mb-3">
                      12
                    </div>
                    <div className="flex flex-col items-center space-y-1">
                      <div className="h-1 w-12 md:w-20 bg-navy-900 rounded-full"></div>
                      <p className="font-display text-lg md:text-2xl font-semibold text-navy-900 tracking-wider">
                        YIL
                      </p>
                      <p className="font-display text-base md:text-xl font-light text-navy-700">
                        DENEYİM
                      </p>
                    </div>
                  </div>
                  
                  <div className="space-y-2 md:space-y-3">
                    {[
                      'Schengen Vizesi Uzmanlığı',
                      'Amerika Vizesi Danışmanlığı',
                      'İngiltere Vizesi Desteği',
                      'Oturum Kartı İşlemleri',
                      'Aile Birleşimi Süreçleri',
                      'E-Vize Hizmetleri',
                    ].map((item, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <i className="ri-checkbox-circle-fill text-green-600 text-sm md:text-lg"></i>
                        <span className="text-navy-900 font-medium text-xs md:text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-8 md:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-6 md:mb-10">
              <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-navy-900 mb-2 md:mb-3">
                Uzman Ekibimiz
              </h2>
              <p className="text-navy-600 text-sm md:text-base max-w-2xl mx-auto">
                İzmir vize danışmanlığı alanında deneyimli ve profesyonel kadromuz, 
                başvuru sürecinizin her aşamasında yanınızda
              </p>
            </div>

            <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-xl md:rounded-2xl p-5 md:p-10 text-center">
              <i className="ri-team-line text-3xl md:text-5xl text-cream-400 mb-3 md:mb-5"></i>
              <h3 className="font-display text-lg md:text-2xl font-bold text-cream-100 mb-2 md:mb-3">
                Profesyonel Kadro
              </h3>
              <p className="text-cream-200 text-sm md:text-base max-w-3xl mx-auto leading-relaxed mb-4 md:mb-6">
                Ekibimiz, vize mevzuatları konusunda sürekli eğitim alan, güncel gelişmeleri yakından 
                takip eden ve müşteri memnuniyetini ön planda tutan uzmanlardan oluşmaktadır. 
                Her bir ekip üyemiz, İzmir vize danışmanlığı alanında yılların getirdiği tecrübe ve 
                bilgi birikimine sahiptir.
              </p>
              <div className="flex flex-wrap justify-center gap-2 md:gap-3">
                {[
                  'Vize Uzmanları',
                  'Hukuk Danışmanları',
                  'Evrak Kontrol Ekibi',
                  'Müşteri İlişkileri',
                ].map((role, index) => (
                  <span
                    key={index}
                    className="px-3 py-1.5 md:px-5 md:py-2 bg-cream-400 text-navy-900 rounded-full font-semibold text-xs md:text-sm"
                  >
                    {role}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-8 md:py-16 bg-cream-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-navy-900 mb-3 md:mb-4">
              Bizimle Çalışmaya Başlayın
            </h2>
            <p className="text-navy-600 text-sm md:text-base mb-4 md:mb-6">
              12 yıllık deneyimimiz ve profesyonel ekibimizle vize sürecinizde yanınızdayız
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
              <a
                href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-2.5 md:px-6 md:py-3 bg-green-600 text-white rounded-full font-semibold text-sm md:text-base hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-lg md:text-xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-5 py-2.5 md:px-6 md:py-3 bg-navy-900 text-cream-100 rounded-full font-semibold text-sm md:text-base hover:bg-navy-800 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-lg md:text-xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default AboutPage;